import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logoconsota',
  templateUrl: './logoconsota.component.html',
  styles: []
})
export class LogoconsotaComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
